import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import GridInfoText from '../GridInfoText';
import { ClientLobSelection } from '../LineOfBusinessSelector/ClientLobSelection';

const useStyles = makeStyles(theme => ({
  items: {
    paddingTop: theme.spacing(2),
  },
  wrapper: {
    paddingTop: theme.spacing(2.5),
  },
}));

export default function UserInfoGrid(data) {
  const { user, updateUser, epiAccess } = data;
  const { id, clients, businessLines } = user;
  const classes = useStyles();
  const isAdmin = !!user.isAdmin;
  const isInternal = !!user.isInternal;
  const toggleAdmin = () => updateUser(id, { isAdmin: !isAdmin });
  const toggleInternal = () => updateUser(id, { isInternal: !isInternal });
  const updateLinesOfBusiness = lob => updateUser(id, { businessLines: lob });
  return (
    <Grid className={classes.wrapper} maxwidth="lg">
      <Grid item xs={12} container className={classes.items} spacing={1} wrap="nowrap">
        <GridInfoText name="ID" value={user.id} />
        <GridInfoText name="Email" value={`${user.email}`} />
      </Grid>
      <Grid item xs={12} container className={classes.items} spacing={1} wrap="nowrap">
        <GridInfoText name="Created" value={user.createdAt} />
      </Grid>
      <Grid item xs={12} className={classes.items}>
        <FormControlLabel
          control={
            <Checkbox name="isAdmin" checked={isAdmin} onChange={toggleAdmin} color="primary" />
          }
          label="Admin"
        />
        {epiAccess.isInternal ? (
          <FormControlLabel
            control={
              <Checkbox
                name="isInternal"
                checked={isInternal}
                onChange={toggleInternal}
                color="primary"
              />
            }
            label="Internal"
          />
        ) : (
          <></>
        )}
      </Grid>
      <Grid item xs={12} className={classes.items}>
        <ul>
          <ClientLobSelection
            clients={clients || []}
            businessLines={businessLines}
            onChange={updateLinesOfBusiness}
          />
        </ul>
      </Grid>
    </Grid>
  );
}

const clients = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    linesOfBusiness: PropTypes.arrayOf(PropTypes.string),
    meta: PropTypes.shape({
      users: PropTypes.arrayOf(PropTypes.string),
      subscriptions: PropTypes.arrayOf(PropTypes.string),
      privileges: PropTypes.arrayOf(PropTypes.string),
    }),
  })
);

UserInfoGrid.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    createdAt: PropTypes.string,
    isAdmin: PropTypes.bool,
    isInternal: PropTypes.bool,
    clients,
    businessLines: PropTypes.arrayOf(PropTypes.string),
    roles: PropTypes.shape({
      app: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  clients: clients.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  updateUser: PropTypes.func.isRequired,
  epiAccess: PropTypes.shape({
    isInternal: PropTypes.bool,
    isAdmin: PropTypes.bool,
  }).isRequired,
};
